<template>
    <div class="bg-black bg-opacity-25 fixed transform transition duration-700 z-50" :class="tipState ? 'left-0 top-0 w-full h-full flex flex-col justify-between xs:pb-12' : 'top-0 left-0 w-full -translate-y-full' ">
        <div class="bg-white overflow-scroll">
            <default-header 
                type="dark"
                seperatorClasses="bg-primary"
                :masked="false"
            />
            <div class="container mx-auto text-primary space-y-5 pb-8 -mt-10">
                <img :src="lifePassTip" alt="Gif depicting lifepass tips and tricks." class="px-10 pb-8">
                <span class="text-lg font-sans-secondary">{{ $t('pleasenote') }}</span>
                <p class="text-base">{{ $t('pleaseensurelifepass') }}</p>
                <default-button 
                    @click="tipsStateFalse"
                    buttonClasses=""
                    :text="$t('iunderstand')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DefaultHeader from "@/components/Header.vue";
import DefaultButton from "@/components/Button.vue";

export default {
  name: "LifePassTip",
  components: {
    DefaultHeader,
    DefaultButton
  },
  props: [
    'tipState'
  ],
  data() {
    return {
        lifePassTip: require('@/assets/images/gifs/LifePassTip-1_Animationv2.gif'),
    };
  },
  mounted() {
    },
  methods: {
    tipsStateFalse() {
      this.$store.dispatch('setLifePassStatus', false);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>